import z from "zod";

const redisErrorTypeValues = ["CONNECTION_FAILED", "OPERATION_FAILED", "TIMEOUT"] as const;

const redisErrorTypeSchema = z.enum(redisErrorTypeValues);
const RedisErrorType = redisErrorTypeSchema.enum;
type RedisErrorType = z.infer<typeof redisErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type RedisErrors =
  | {
      errorType: typeof RedisErrorType.CONNECTION_FAILED;
      data: { usedTls: boolean; host?: string };
    }
  | {
      errorType: typeof RedisErrorType.OPERATION_FAILED;
      data: { operation: string; key?: string };
    }
  | {
      errorType: typeof RedisErrorType.TIMEOUT;
      data: { operation: string; timeoutMs: number };
    };

export const redisErrorDetails: Record<RedisErrorType, ErrorDetails> = {
  [RedisErrorType.CONNECTION_FAILED]: {
    sentryDescription: "Failed to connect to Redis (Upstash)",
  },
  [RedisErrorType.OPERATION_FAILED]: {
    sentryDescription: "Redis cache operation failed",
  },
  [RedisErrorType.TIMEOUT]: {
    sentryDescription: "Redis cache operation timed out",
  },
};
